import {makeStyles} from '@material-ui/core/styles';

const drawerWidth = 240;

export default makeStyles((theme) => ({
  menuButton: {
    marginInlineStart: 12,
    marginInlineEnd: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    alignItems: 'flex-start',
    zIndex: '1202',
  },
  drawerOpen: {
    position: 'fixed',
    alignItems: 'flex-start',
    top: '0px',
    width: '250px', //drawerWidth,
    height: '100vh',
    zIndex: '1202',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    MuiIconButtonColorInherit: {
      height: '46px',
      width: '46px',
      margin: '5px auto',
      alignItems: 'flex-start',
    },
    position: 'fixed',
    top: '0px',
    height: '100vh',
    zIndex: '1202',
    overflowX: 'hidden',
    width: theme.spacing(7) + 10,
    [theme.breakpoints.down("xs")]: {
      width: "0px",
    },
  },
  toolbar: {
    ...theme.mixins.toolbar,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  sidebarList: {
    width: '100%',
  },
  mobileBackButton: {
    marginTop: theme.spacing(0.5),
    marginInlineStart: theme.spacing(3),
    display: 'none',
    [theme.breakpoints.only('sm')]: {
      marginTop: theme.spacing(0.625),
    },
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },

  headerMenuButton: {
    marginInlineStart: theme.spacing(0.5),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1.2),
    padding: theme.spacing(0.5),
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(4),
    },
    [theme.breakpoints.down('xs')]: {
      display: "none"
    },
  },
  headerMenuButtonCollapse: {
    marginInlineEnd: theme.spacing(2),
    width: '59px',
    height: 'auto',
  },
  headerIcon: {
    fontSize: 28,
    color: '#4e80c5',
  },
  headerIconCollapse: {
    color: '#4e80c5',
  },
  closeSidebarMobile: {
    width: "100%",
    paddingInlineStart: "1rem",
    marginBlock: "1rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  NotesIconDiv: {
    position: 'absolute',
    bottom: '1%',
    display: "flex",
    alignItems: "center",
    paddingBlock: "0.5rem",
    transition: "all 0.3s ease",
    "&:hover": {
      cursor: "pointer",
    },
  },
  NotesIconDivLg: {
    width: 'auto',
    justifyContent: "center",
    background: "#F3F5FF",
    paddingInline: "1rem",
    borderRadius: "0.5rem",
    marginInlineStart: "50%",
    transform: "translateX(-50%)",
    gap: "0.5rem",
    "&:hover": {
      background: "#e6eaff",
    },
  },
  NotesIconDivSm: {
    width: '100%'
  },
  NotesIcon: {
    color: "#0c82da",
    padding: "0px!important",
  },
  NotesLabel: {
    fontSize: "1rem",
    color: "#6E6E6ECC",
  },
  ModalHeaderNotes:{
    display: 'flex',
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'space-around',
    fontSize: '1.5rem',
  },
  ModalFooterNotes:{
    display: 'flex',
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: '1.5rem',
    margin:10
  },
  TextFieldNotes :{
    padding:20,
  }
  
}));
